import PreviousSearch from './previous-search-component';
import PreviousSearchService from './previous-search-service';

import './previous-search.scss';

const MODULE_NAME = 'app.common.previous-search';
const module = angular.module(MODULE_NAME, [
        'App.Services',
    ])
    .directive(PreviousSearch.DIRECTIVE_NAME, PreviousSearch)
    .service('previousSearchService', PreviousSearchService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/previous-search/previous-search-module.js